import { action } from "typesafe-actions";
import { Mcc, MccActionTypes } from "./types";

export const fetchRequest = (
  id?: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(MccActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (payload) =>
  action(MccActionTypes.FETCH_SUCCESS, payload);

export const fetchError = (error: string) =>
  action(MccActionTypes.FETCH_ERROR, error);
